module.exports = __webpack_public_path__ + "img/notification-icon.e0d9ccdb.svg";